import { AppClient } from "~/api"

export const Api = new AppClient({
    BASE: import.meta.env.VITE_LARAVEL,
})